import { Cliente } from './cliente';
import { Tipologia } from './tipologia';
import { Estado } from './estado';
import { Sector } from './sector';
import { KPI } from './kpi';
import { User } from './user';
import { Powerbi } from './powerbi';
import { Sociedad } from './sociedad';

export class Activo {
    constructor(
        public id?: number,
        public nombre?: string,
        public codigo?: string,
        public cliente?: Cliente,
        public ciudad?: string,
        public direccion?: string,
        public tipologia?: Tipologia,
        public sector?: Sector,
        public estado?: Estado,
        public enlace?: string,
        public latitud?: number,
        public longitud?: number,
        public imagen?: any,
        public thumbnail?: any,
        public kpis?: Array<KPI>,
        public users?: Array<User>,
        public carpetaAWS?: string,
        public power_b_i?: Array<Powerbi>,
        public sociedad?: Sociedad,
        public descripcion?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/core/modelos/activo.ts